/**
 * Score-form field types.
 *
 * Shared by api (score-forms DTOs) and web (score-forms API client + scoring
 * components). Pure shapes — the api keeps its class-validator DTO classes
 * (`FieldDefinitionDto`, `FieldOptionDto`) which decorate these fields; those
 * classes may `implements` the interfaces here.
 *
 * NOTE: the score-form formula token tree reuses {@link ScoringFormulaNode}
 * from `ranking.ts` (a superset) — do NOT add a colliding `FormulaNode` here.
 */
/**
 * Kind of a score-form field.
 */
export var FieldType;
(function (FieldType) {
    FieldType["CHOICE"] = "CHOICE";
    FieldType["NUMBER"] = "NUMBER";
    FieldType["CHECKBOX"] = "CHECKBOX";
    FieldType["TIMER"] = "TIMER";
    FieldType["TEXT"] = "TEXT";
})(FieldType || (FieldType = {}));
//# sourceMappingURL=score-form.js.map